import Page from "@containers/Page/Page";
import PageContent from "@containers/PageContent/PageContent";
import MacDetailsObsolete from "@pages/Documents/Mac/MacDetailsObsolete";
import Scrollbars from "react-custom-scrollbars";

const MacObsolete = () => {
    return (
        /* @ts-ignore */
        <Page>
            <PageContent>
                <Scrollbars renderView={props => <div {...props} id="view-document__scrollbar-view"/>}>
                    <MacDetailsObsolete documentInfo={{ docType: "mac" }} />
                </Scrollbars>
            </PageContent>
        </Page>
    );
};

export default MacObsolete;
